import { trackSeoExplorePageFeaturedBrandsClick } from "@faire/web-api/events/seo/click/explorePageFeaturedBrands";
import { trackSeoExplorePageFeaturedBrandsView } from "@faire/web-api/events/seo/view/explorePageFeaturedBrands";
import { WhenVisibilityIsImminent } from "@faire/web/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React, { Suspense } from "react";

import { LazySearchCategoryCarousel } from "@faire/retailer/components/SearchProducts/SearchCategoryCarousel";
import { CarouselFallback } from "@faire/retailer/components/SearchProducts/SearchProductsStyles";
import { useExplorePageProductsQuery } from "@faire/retailer/views/explore-page/__internal__/useExplorePageProductsQuery";

export const ExplorePageFeaturedBrandsCarousel: React.FC = () => {
  const { brands, requestId } = useExplorePageProductsQuery();
  return (
    <WhenVisibilityIsImminent customizePlaceholder={<CarouselFallback />}>
      <Suspense fallback={<CarouselFallback />}>
        <LazySearchCategoryCarousel
          brands={brands}
          requestId={requestId}
          onClick={(brandToken) => {
            trackSeoExplorePageFeaturedBrandsClick(brandToken);
          }}
          onView={trackSeoExplorePageFeaturedBrandsView}
        />
      </Suspense>
    </WhenVisibilityIsImminent>
  );
};
